import { passkeyClient } from "@better-auth/passkey/client";
import { createAuthClient } from "better-auth/react";

/**
 * The operator's sign-in (ADR 0016): Better Auth's client with its passkey plugin, against the
 * admin app's server (/api/auth). There is no password and no sign-up.
 */
export const authClient = createAuthClient({ plugins: [passkeyClient()] });

/** A Better Auth error's code, when it has one (OPERATOR_LINK_INVALID from the server). */
export function authErrorCode(error: unknown): string | null {
  const code = (error as { code?: unknown } | null)?.code;
  return typeof code === "string" ? code : null;
}
